import { theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles(() =>
  createStyles({
    errorBanner: {
      width: '100%',
    },
    title: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(8),
    },
    buttonLeft: {
      paddingLeft: 0,
    },
    textField: {
      '&.MuiSvgIcon-colorAction, .MuiSvgIcon-colorAction': {
        display: 'none',
      },
    },
    buttonsContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginBottom: theme.spacing(1),
    },
    primaryButton: {
      marginLeft: theme.spacing(2),
    },
  })
);
